export const ALL_ID = '-1';

export enum SpotifySize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  BIG = 'BIG',
}

export enum ReferralTypeEnum {
  E_LINK = 'E_LINK', // ecommerce link
  CODE = 'CODE',
  P_LINK = 'P_LINK', // program link
}

export interface NamedProfile {
  firstName?: string;
  lastName?: string;
}

export type NameFormat = 'fullname' | 'onlyFirstname' | 'firstNameInitialLastname' | 'fullInitials';

export const nameFormatters: { [format: string]: (profile: NamedProfile) => string } = {
  fullname,
  onlyFirstname,
  firstNameInitialLastname,
  fullInitials,
};

function getInitials(str: string, separator = ' ', suffix = '.'): string {
  const initials: string = str
    .split(separator)
    .map(word => {
      if (/(-)+/i.test(word)) {
        return getInitials(word, '-', '');
      }

      return word.charAt(0).toUpperCase();
    })
    .join('');

  return initials + suffix;
}

function capitalize(str: string, separator = ' '): string {
  if (typeof str !== 'string') {
    return '';
  }

  return str
    .split(separator)
    .map(word => {
      if (/(-)+/i.test(word)) {
        return capitalize(word, '-');
      }

      const lowerCasedWord = word.toLowerCase();
      return lowerCasedWord.charAt(0).toUpperCase() + lowerCasedWord.slice(1);
    })
    .join(separator);
}

export function fullname(profile: NamedProfile): string {
  return capitalize(`${profile.firstName || ''} ${profile.lastName || ''}`).trim();
}

export function onlyFirstname(profile: NamedProfile): string {
  return capitalize(profile.firstName || '');
}

// To be improved
export function firstNameInitialLastname(profile: NamedProfile): string {
  return `${capitalize(profile.firstName || '')} ${getInitials(profile.lastName || '')}`.trim();
}

// To be improved
export function fullInitials(profile: NamedProfile): string {
  return getInitials(`${profile.firstName || ''} ${profile.lastName || ''}`).trim();
}

export function formatNumber(
  value: number,
  { locale = 'en', ...options }: Intl.NumberFormatOptions & { locale?: string },
): string {
  return Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(value);
}
